export class PRC_WELL {
  static formatSecondsToTime = (hours, minutes, seconds) => {
    // Convert hours, minutes, and seconds into total seconds
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    // Convert total seconds into HH:MM:SS format
    const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0"); // Hours
    const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0"); // Minutes
    const s = String(totalSeconds % 60).padStart(2, "0"); // Seconds

    return `${h}:${m}:${s}`;
  };

  // Function to format hours (HH)
  static formatHours = (hours) => {
    return String(hours).padStart(2, "0"); // Pads the hour with leading zero
  };

  static loadValue = (reg, unit) => {
    return reg ? `${reg} ${unit}` : "loading...";
  };

  static getWellStateName = (value) => {
    switch (value) {
      case 0:
        return "STANDBY";
      case 10:
        return "OPEN";
      case 20:
        return "AFTERFLOW";
      case 30:
        return "SHUTIN";
      case 40:
        return "MANDATORY";
      default:
        return "-";
    }
  };

  static getSDAsync = async () => {
    const C5SDDict = {
      0: "",
      1: "LOCAL EMERGENCY STOP SHUTDOWN",
      2: "COMPRESSOR DI02 SHUTDOWN",
      3: "MAIN MOTOR FAIL  ",
      4: "COOLER FAN MOTOR FAIL ",
      5: "COMPRESSOR DI05 SHUTDOWN",
      6: "COMPRESSOR DI06 SHUTDOWN",
      7: "LOW ENGINE OIL LEVEL SHUTDOWN ",
      8: "LOW ENGINE JACKET WATER LEVEL SHUTDOWN ",
      9: "COMPRESSOR DI09 SHUTDOWN",
      10: "HIGH 1ST STAGE SCRUBBER LIQUID LEVEL SHUTDOWN",
      11: "HIGH 2ND STAGE SCRUBBER LIQUID LEVEL SHUTDOWN",
      12: "ALARM VFD Replace Battery",
      13: "VFD PANEL SHUTDOWN",
      14: "HI COMPRESSOR VIBRATION",
      15: "COMPRESSOR DI15 SHUTDOWN",
      16: "COMPRESSOR DI16 SHUTDOWN",
      17: "COMPRESSOR DI17 SHUTDOWN",
      18: "COMPRESSOR DI18 SHUTDOWN",
      19: "COMPRESSOR DI19 SHUTDOWN",
      20: "COMPRESSOR DI20 SHUTDOWN",
      22: "COMPRESSOR DI22 SHUTDOWN",
      23: "COMPRESSOR DI23 SHUTDOWN",
      24: "COMPRESSOR DI24 SHUTDOWN",
      25: "COMPRESSOR DI25 SHUTDOWN",
      26: "COMPRESSOR DI26 SHUTDOWN",
      27: "COMPRESSOR DI27 SHUTDOWN",
      28: "COMPRESSOR DI28 SHUTDOWN",
      29: "CUSTOMER WATER TANK SD",
      31: "PLUNGER 1 TANK KILL 1",
      32: "PLUNGER 1 TANK KILL 2",
      34: "PLUNGER 2 TANK KILL 1",
      35: "PLUNGER 2 TANK KILL 2",
      37: "PLUNGER 3 TANK KILL 1",
      38: "PLUNGER 3 TANK KILL 2",
      40: "PLUNGER 4 TANK KILL 1",
      41: "PLUNGER 4 TANK KILL 2",
      42: "PLUNGER LIFT_1 DI10",
      43: "PLUNGER LIFT_1 DI11",
      44: "PLUNGER LIFT_1 DI12",
      45: "PLUNGER LIFT_1 DI13",
      46: "PLUNGER LIFT_1 DI14",
      47: "PLUNGER LIFT_1 DI15",
      48: "PLUNGER LIFT_1 DI16",
      49: "PLUNGER LIFT_1 DI17",
      50: "PLUNGER LIFT_1 DI18",
      51: "PLUNGER LIFT_1 DI19",
      52: "PLUNGER LIFT_1 DI20",
      53: "PLUNGER LIFT_1 DI21",
      54: "PLUNGER LIFT_1 DI22",
      55: "PLUNGER LIFT_1 DI23",
      56: "PLUNGER LIFT_1 DI24",
      57: "PLUNGER LIFT_2 DI01",
      58: "PLUNGER LIFT_2 DI02",
      59: "PLUNGER LIFT_2 DI03",
      60: "PLUNGER LIFT_2 DI04",
      61: "PLUNGER LIFT_2 DI05",
      62: "PLUNGER LIFT_2 DI06",
      63: "PLUNGER LIFT_2 DI07",
      64: "PLUNGER LIFT_2 DI08",
      65: "PLUNGER LIFT_2 DI09",
      66: "PLUNGER LIFT_2 DI10",
      67: "PLUNGER LIFT_2 DI11",
      68: "PLUNGER LIFT_2 DI12",
      69: "PLUNGER LIFT_2 DI13",
      70: "PLUNGER LIFT_2 DI14",
      71: "PLUNGER LIFT_2 DI15",
      72: "PLUNGER LIFT_2 DI16",
      73: "PLUNGER LIFT_2 DI17",
      74: "PLUNGER LIFT_2 DI18",
      75: "PLUNGER LIFT_2 DI19",
      76: "PLUNGER LIFT_2 DI20",
      77: "PLUNGER LIFT_2 DI21",
      78: "PLUNGER LIFT_2 DI22",
      79: "PLUNGER LIFT_2 DI23",
      80: "PLUNGER LIFT_2 DI24",
      81: "PLUNGER LIFT_3 DI01",
      82: "PLUNGER LIFT_3 DI02",
      83: "PLUNGER LIFT_3 DI03",
      84: "PLUNGER LIFT_3 DI04",
      85: "PLUNGER LIFT_3 DI05",
      86: "PLUNGER LIFT_3 DI06",
      87: "PLUNGER LIFT_3 DI07",
      88: "PLUNGER LIFT_3 DI08",
      89: "PLUNGER LIFT_3 DI09",
      90: "PLUNGER LIFT_3 DI10",
      91: "PLUNGER LIFT_3 DI11",
      92: "PLUNGER LIFT_3 DI12",
      93: "PLUNGER LIFT_3 DI13",
      94: "PLUNGER LIFT_3 DI14",
      95: "PLUNGER LIFT_3 DI15",
      96: "PLUNGER LIFT_3 DI16",
      97: "PLUNGER LIFT_3 DI17",
      98: "PLUNGER LIFT_3 DI18",
      99: "PLUNGER LIFT_3 DI19",
      100: "PLUNGER LIFT_3 DI20",
      101: "PLUNGER LIFT_3 DI21",
      102: "PLUNGER LIFT_3 DI22",
      103: "PLUNGER LIFT_3 DI23",
      104: "PLUNGER LIFT_3 DI24",
      116: "Unexpected Driver Start",
      117: "Driver Failure To Start",
      118: "Compressor Prelube Permissive Failure",
      120: "Driver Failure To Stop",
      122: "MANUAL STOP IN AUTO",
      123: "ENGINE STOP LAMP SHUTDOWN",
      124: "LOST J1939 COMMS SHUTDOWN ",
      125: "LOST RPM/STALL",
      126: "PLUNGER 1 Mandatory Shutin",
      127: "PLUNGER 2 Mandatory Shutin",
      128: "PLUNGER 3 Mandatory Shutin",
      129: "PLUNGER 4 Mandatory Shutin",
      130: "Motor Short Cycle SD",
      141: "Field Pressure Xmtr Under/Overrange",
      142: "Interstage Pressure Xmtr Under/Overrange",
      143: "Main Discharge Pressure Xmtr Under/Overrange",
      144: "Main Flow Rate Xmtr Under/Overrange",
      145: "Suction Scrubber Pressure Xmtr Under/Overrange",
      146: "Compressor Oil Pressure Xmtr Under/Overrange",
      147: "PLUNGER 1 Casing Pressure Xmtr Under/Overrange",
      148: "PLUNGER 1 Tubing Pressure Xmtr Under/Overrange",
      149: "PLUNGER 1 Flow Rate Xmtr Under/Overrange",
      150: "Main Motor Speed Reference Under/Overrange",
      151: "Main Motor Amps Xmtr Under/Overrange",
      152: "Cooler Motor Amps Xmtr Under/Overrange",
      153: "PLUNGER 2 Casing Pressure Xmtr Under/Overrange",
      154: "PLUNGER 2 Tubing Pressure Xmtr Under/Overrange",
      155: "PLUNGER 2 Flow Rate Xmtr Under/Overrange",
      156: "PLUNGER 3 Casing Pressure Xmtr Under/Overrange",
      157: "PLUNGER 3 Tubing Pressure Xmtr Under/Overrange",
      158: "PLUNGER 3 Flow Rate Xmtr Under/Overrange",
      159: "PLUNGER 4 Casing Pressure Xmtr Under/Overrange",
      160: "PLUNGER 4 Tubing Pressure Xmtr Under/Overrange",
      161: "PLUNGER 4 Flow Rate Xmtr Under/Overrange",
      162: "PLUNGER LIFT_1 AI10 Xmtr Under/Overrange",
      163: "PLUNGER LIFT_2 AI01 Xmtr Under/Overrange",
      164: "PLUNGER LIFT_2 AI02 Xmtr Under/Overrange",
      165: "PLUNGER LIFT_2 AI03 Xmtr Under/Overrange",
      166: "PLUNGER LIFT_2 AI04 Xmtr Under/Overrange",
      167: "PLUNGER LIFT_2 AI05 Xmtr Under/Overrange",
      168: "PLUNGER LIFT_2 AI06 Xmtr Under/Overrange",
      169: "PLUNGER LIFT_2 AI07 Xmtr Under/Overrange",
      170: "PLUNGER LIFT_2 AI08 Xmtr Under/Overrange",
      171: "PLUNGER LIFT_2 AI09 Xmtr Under/Overrange",
      172: "PLUNGER LIFT_2 AI10 Xmtr Under/Overrange",
      173: "PLUNGER LIFT_3 AI01 Xmtr Under/Overrange",
      174: "PLUNGER LIFT_3 AI02 Xmtr Under/Overrange",
      175: "PLUNGER LIFT_3 AI03 Xmtr Under/Overrange",
      176: "PLUNGER LIFT_3 AI04 Xmtr Under/Overrange",
      177: "PLUNGER LIFT_3 AI05 Xmtr Under/Overrange",
      178: "PLUNGER LIFT_3 AI06 Xmtr Under/Overrange",
      179: "PLUNGER LIFT_3 AI07 Xmtr Under/Overrange",
      180: "PLUNGER LIFT_3 AI08 Xmtr Under/Overrange",
      181: "PLUNGER LIFT_3 AI09 Xmtr Under/Overrange",
      182: "PLUNGER LIFT_3 AI10 Xmtr Under/Overrange",
      183: "Discharge Temp Wire Fault",
      184: "Discharge #2 Temp Wire Fault",
      185: "Tail Shaft Wire Fault",
      186: "Air Compressor Temp Wire Fault",
      187: "TI05 Wire Fault",
      188: "TI06 Wire Fault",
      189: "TI07 Wire Fault",
      190: "Ambient Temp Wire Fault",
      336: "ALARM Hi Tail Shaft Temperature",
      338: "ALARM Hi Air Compressor Temp",
      455: "LoLo System Voltage",
      456: "HiHi System Voltage",
      457: "LoLo Field Pressure",
      458: "HiHi Field Pressure",
      459: "LoLo Interstage Pressure",
      460: "HiHi Interstage Pressure",
      461: "LoLo Main Discharge Pressure",
      462: "HiHi Main Discharge Pressure",
      463: "LoLo Main Flow Rate",
      464: "HiHi Main Flow Rate",
      465: "LoLo Suction Scrubber Pressure",
      466: "HiHi Suction Scrubber Pressure",
      467: "LoLo Compressor Oil Pressure",
      468: "HiHi Compressor Oil Pressure",
      469: "LoLo PLUNGER 1 Casing Pressure",
      470: "HiHi PLUNGER 1 Casing Pressure",
      471: "LoLo PLUNGER 1 Tubing Pressure",
      472: "HiHi PLUNGER 1 Tubing Pressure",
      473: "LoLo PLUNGER 1 Flow Rate",
      474: "HiHi PLUNGER 1 Flow Rate",
      475: "LoLo AI10",
      476: "HiHi AI10",
      477: "LoLo Main Motor Amps",
      478: "HiHi Main Motor Amps",
      479: "LoLo Cooler Motor Amps",
      480: "HiHi Cooler Motor Amps",
      481: "LoLo PLUNGER 2 Casing Pressure",
      482: "HiHi PLUNGER 2 Casing Pressure",
      483: "LoLo PLUNGER 2 Tubing Pressure",
      484: "HiHi PLUNGER 2 Tubing Pressure",
      485: "LoLo PLUNGER 2 Flow Rate",
      486: "HiHi PLUNGER 2 Flow Rate",
      487: "LoLo PLUNGER 3 Casing Pressure",
      488: "HiHi PLUNGER 3 Casing Pressure",
      489: "LoLo PLUNGER 3 Tubing Pressure",
      490: "HiHi PLUNGER 3 Tubing Pressure",
      491: "LoLo PLUNGER 3 Flow Rate",
      492: "HiHi PLUNGER 3 Flow Rate",
      493: "LoLo PLUNGER 4 Casing Pressure",
      494: "HiHi PLUNGER 4 Casing Pressure",
      495: "LoLo PLUNGER 4 Tubing Pressure",
      496: "HiHi PLUNGER 4 Tubing Pressure",
      497: "LoLo PLUNGER 4 Flow Rate",
      498: "HiHi PLUNGER 4 Flow Rate",
      499: "PLUNGER LIFT_1 LoLo AI10",
      500: "PLUNGER LIFT_1 HiHi AI10",
      501: "PLUNGER LIFT_2 LoLo AI01",
      502: "PLUNGER LIFT_2 HiHi AI01",
      503: "PLUNGER LIFT_2 LoLo AI02",
      504: "PLUNGER LIFT_2 HiHi AI02",
      505: "PLUNGER LIFT_2 LoLo AI03",
      506: "PLUNGER LIFT_2 HiHi AI03",
      507: "PLUNGER LIFT_2 LoLo AI04",
      508: "PLUNGER LIFT_2 HiHi AI04",
      509: "PLUNGER LIFT_2 LoLo AI05",
      510: "PLUNGER LIFT_2 HiHi AI05",
      511: "PLUNGER LIFT_2 LoLo AI06",
      512: "PLUNGER LIFT_2 HiHi AI06",
      513: "PLUNGER LIFT_2 LoLo AI07",
      514: "PLUNGER LIFT_2 HiHi AI07",
      515: "PLUNGER LIFT_2 LoLo AI08",
      516: "PLUNGER LIFT_2 HiHi AI08",
      517: "PLUNGER LIFT_2 LoLo AI09",
      518: "PLUNGER LIFT_2 HiHi AI09",
      519: "PLUNGER LIFT_2 LoLo AI10",
      520: "PLUNGER LIFT_2 HiHi AI10",
      521: "PLUNGER LIFT_3 LoLo AI01",
      522: "PLUNGER LIFT_3 HiHi AI01",
      523: "PLUNGER LIFT_3 LoLo AI02",
      524: "PLUNGER LIFT_3 HiHi AI02",
      525: "PLUNGER LIFT_3 LoLo AI03",
      526: "PLUNGER LIFT_3 HiHi AI03",
      527: "PLUNGER LIFT_3 LoLo AI04",
      528: "PLUNGER LIFT_3 HiHi AI04",
      529: "PLUNGER LIFT_3 LoLo AI05",
      530: "PLUNGER LIFT_3 HiHi AI05",
      531: "PLUNGER LIFT_3 LoLo AI06",
      532: "PLUNGER LIFT_3 HiHi AI06",
      533: "PLUNGER LIFT_3 LoLo AI07",
      534: "PLUNGER LIFT_3 HiHi AI07",
      535: "PLUNGER LIFT_3 LoLo AI08",
      536: "PLUNGER LIFT_3 HiHi AI08",
      537: "PLUNGER LIFT_3 LoLo AI09",
      538: "PLUNGER LIFT_3 HiHi AI09",
      539: "PLUNGER LIFT_3 LoLo AI10",
      540: "PLUNGER LIFT_3 HiHi AI10",
      541: "LoLo Discharge 1 Temperature",
      542: "HiHi Discharge 1 Temperature",
      543: "LoLo Discharge #2 Temperature",
      544: "HiHi Discharge #2 Temperature",
      545: "LoLo Tail Shaft Temperature",
      546: "HiHi Tail Shaft Temperature",
      547: "LoLo Air Compressor Temp",
      548: "HiHi Air Compressor Temp",
      549: "LoLo TI05",
      550: "HiHi TI05",
      551: "LoLo TI06",
      552: "HiHi TI06",
      553: "LoLo TI07",
      554: "HiHi TI07",
      555: "LoLo Ambient Temp",
      556: "HiHi Ambient Temp",
      682: "ALARM PLUNGER 1 Max Under Runs ",
      683: "ALARM PLUNGER 2 Max Under Runs ",
      684: "ALARM PLUNGER 3 Max Under Runs ",
      685: "ALARM PLUNGER 4 Max Under Runs ",
      686: "ALARM PLUNGER 1 Max Over Runs ",
      687: "ALARM PLUNGER 2 Max Over Runs ",
      688: "ALARM PLUNGER 3 Max Over Runs ",
      689: "ALARM PLUNGER 4 Max Over Runs ",
      694: "COMPRESSOR SD on PLNGER 1 SD",
      695: "COMPRESSOR SD on PLNGER 2 SD",
      696: "COMPRESSOR SD on PLNGER 3 SD",
      697: "COMPRESSOR SD on PLNGER 4 SD",
      748: "Panel Emergency Stop Wire Fault",
      749: "DI02 Wire Fault",
      750: "Main Motor Running Feedback Wire Fault",
      751: "Cooler Fan Motor Running Feedback Wire Fault",
      752: "DI05 Wire Fault",
      753: "DI06 Wire Fault",
      754: "Low Engine Oil Level Wire Fault ",
      755: "Low Engine Jacket Water Level Wire Fault ",
      756: "DI09 Wire Fault",
      757: "High Stage 1 Scrubber Liquid Level Wire Fault",
      758: "High Stage 2 Scrubber Liquid Level Wire Fault",
      759: "ALARM Replace Battery",
      760: "DI13 Wire Fault",
      761: "High Compressor Vibration Wire Fault",
      762: "DI15 Wire Fault",
      763: "DI16 Wire Fault",
      764: "DI17 Wire Fault",
      765: "DI18 Wire Fault",
      766: "DI19 Wire Fault",
      767: "DI20 Wire Fault",
      768: "ROC Override Wire Fault",
      769: "DI22 Wire Fault",
      770: "DI23 Wire Fault",
      771: "DI24 Wire Fault",
      772: "DI25 Wire Fault",
      773: "DI26 Wire Fault",
      774: "DI27 Wire Fault",
      775: "DI28 Wire Fault",
      776: "DI29 Wire Fault",
      777: "PLUNGER 1 Arrival Monitor Wire Fault",
      778: "PLUNGER 1 Tank Kill 1 Wire Fault",
      779: "PLUNGER 1 Tank Kill 2 Wire Fault",
      780: "PLUNGER 2 Arrival Monitor Wire Fault",
      781: "PLUNGER 2 Tank Kill 1 Wire Fault",
      782: "PLUNGER 2 Tank Kill 2 Wire Fault",
      783: "PLUNGER 3 Arrival Monitor Wire Fault",
      784: "PLUNGER 3 Tank Kill 1 Wire Fault",
      785: "PLUNGER 3 Tank Kill 2 Wire Fault",
      786: "PLUNGER 4 Arrival Monitor Wire Fault",
      787: "PLUNGER 4 Tank Kill 1 Wire Fault",
      788: "PLUNGER 4 Tank Kill 2 Wire Fault",
      789: "PLUNGER LIFT_1 DI10 Wire Fault",
      790: "PLUNGER LIFT_1 DI11 Wire Fault",
      791: "PLUNGER LIFT_1 DI12 Wire Fault",
      792: "PLUNGER LIFT_1 DI13 Wire Fault",
      793: "PLUNGER LIFT_1 DI14 Wire Fault",
      794: "PLUNGER LIFT_1 DI15 Wire Fault",
      795: "PLUNGER LIFT_1 DI16 Wire Fault",
      796: "PLUNGER LIFT_1 DI17 Wire Fault",
      797: "PLUNGER LIFT_1 DI18 Wire Fault",
      798: "PLUNGER LIFT_1 DI19 Wire Fault",
      799: "PLUNGER LIFT_1 DI20 Wire Fault",
      800: "PLUNGER LIFT_1 DI21 Wire Fault",
      801: "PLUNGER LIFT_1 DI22 Wire Fault",
      802: "PLUNGER LIFT_1 DI23 Wire Fault",
      803: "PLUNGER LIFT_1 DI24 Wire Fault",
      804: "PLUNGER LIFT_2 DI01 Wire Fault",
      805: "PLUNGER LIFT_2 DI02 Wire Fault",
      806: "PLUNGER LIFT_2 DI03 Wire Fault",
      807: "PLUNGER LIFT_2 DI04 Wire Fault",
      808: "PLUNGER LIFT_2 DI05 Wire Fault",
      809: "PLUNGER LIFT_2 DI06 Wire Fault",
      810: "PLUNGER LIFT_2 DI07 Wire Fault",
      811: "PLUNGER LIFT_2 DI08 Wire Fault",
      812: "PLUNGER LIFT_2 DI09 Wire Fault",
      813: "PLUNGER LIFT_2 DI10 Wire Fault",
      814: "PLUNGER LIFT_2 DI11 Wire Fault",
      815: "PLUNGER LIFT_2 DI12 Wire Fault",
      816: "PLUNGER LIFT_2 DI13 Wire Fault",
      817: "PLUNGER LIFT_2 DI14 Wire Fault",
      818: "PLUNGER LIFT_2 DI15 Wire Fault",
      819: "PLUNGER LIFT_2 DI16 Wire Fault",
      820: "PLUNGER LIFT_2 DI17 Wire Fault",
      821: "PLUNGER LIFT_2 DI18 Wire Fault",
      822: "PLUNGER LIFT_2 DI19 Wire Fault",
      823: "PLUNGER LIFT_2 DI20 Wire Fault",
      824: "PLUNGER LIFT_2 DI21 Wire Fault",
      825: "PLUNGER LIFT_2 DI22 Wire Fault",
      826: "PLUNGER LIFT_2 DI23 Wire Fault",
      827: "PLUNGER LIFT_2 DI24 Wire Fault",
      828: "PLUNGER LIFT_3 DI01 Wire Fault",
      829: "PLUNGER LIFT_3 DI02 Wire Fault",
      830: "PLUNGER LIFT_3 DI03 Wire Fault",
      831: "PLUNGER LIFT_3 DI04 Wire Fault",
      832: "PLUNGER LIFT_3 DI05 Wire Fault",
      833: "PLUNGER LIFT_3 DI06 Wire Fault",
      834: "PLUNGER LIFT_3 DI07 Wire Fault",
      835: "PLUNGER LIFT_3 DI08 Wire Fault",
      836: "PLUNGER LIFT_3 DI09 Wire Fault",
      837: "PLUNGER LIFT_3 DI10 Wire Fault",
      838: "PLUNGER LIFT_3 DI11 Wire Fault",
      839: "PLUNGER LIFT_3 DI12 Wire Fault",
      840: "PLUNGER LIFT_3 DI13 Wire Fault",
      841: "PLUNGER LIFT_3 DI14 Wire Fault",
      842: "PLUNGER LIFT_3 DI15 Wire Fault",
      843: "PLUNGER LIFT_3 DI16 Wire Fault",
      844: "PLUNGER LIFT_3 DI17 Wire Fault",
      845: "PLUNGER LIFT_3 DI18 Wire Fault",
      846: "PLUNGER LIFT_3 DI19 Wire Fault",
      847: "PLUNGER LIFT_3 DI20 Wire Fault",
      848: "PLUNGER LIFT_3 DI21 Wire Fault",
    };
    const WPIISDDict = {
      1: "Low Engine Oil Level SD *configurable",
      2: "Low Engine Jacket Water Level SD*configurable",
      3: "High 1st Stage Scrubber Level SD *configurable",
      4: "High 2nd Stage Scrubber Level SD *configurable",
      5: "ROC Override Active *configurable",
      6: "High Compressor Vibration SD *configurable",
      7: "Spare DI07 *configurable",
      8: "Local Panel Emergency Stop *configurable",
      9: "Failure to Start",
      12: "Failure To Crank",
      15: "Lost Engine J1939 Comm",
      16: "Modbus Shutdown",
      21: "Lost Speed Signal/Engine Stall",
      22: "Lost Field Pressure Xmtr",
      23: "Lost Interstage Discharge Pressure Xmtr",
      24: "Lost Discharge Pressure Xmtr",
      25: "Lost Suction Scrubber Pressure Xmtr",
      26: "Lost Compressor Oil Pressure Xmtr",
      29: "Cold Junction TC Break",
      30: "Thermocouple CH1 TC Break",
      31: "Discharge Temperature TC Break",
      38: "LoLo System Voltage",
      41: "HiHi System Voltage",
      42: "LoLo Field Pressure",
      45: "HiHi Field Pressure",
      46: "LoLo Interstage Discharge Pressure",
      49: "HiHi Interstage Discharge Pressure",
      50: "LoLo Discharge Pressure",
      53: "HiHi Discharge Pressure",
      58: "LoLo Compressor Oil Pressure",
      61: "HiHi Compressor Oil Pressure",
      62: "LoLo Suction Scrubber Pressure",
      65: "HiHi Suction Scrubber Pressure",
      78: "HiHi Discharge Temperature",
      94: "HiHi Discharge 2 Temperature",
      95: "Manual Stop In Auto",
    };
    const data = { C5: C5SDDict, WP: WPIISDDict };
    try {
      if (data) {
        return data;
      } else {
        throw new Error("No SD returned");
      }
    } catch (err) {
      console.error("Failed to get SD", err);
      return null;
    }
  };

  static getValueFromWell = (regDict, label) => {
    const getValue = regDict.find((item) => item.label === label);
    return getValue;
  };

  static getAnalogSetpointsValueFromWell = (regDict, label) => {
    if (!Array.isArray(regDict)) return null;
    for (const bloc of regDict) {
      if (Array.isArray(bloc.fields)) {
        const field = bloc.fields.find((f) => f.label === label);
        if (field) return field;
      }
    }
    return null;
  };
  static getStateDescriptions(ctrlType, state, shutdownCode) {
    const stateNum = Number(state);
    const shutdownNum = Number(shutdownCode);
    let stateDescr = "STANDBY";
    let shutdownDescr = "SHUTDOWN";
    if (ctrlType === "WellPro II") {
      // --- STATE DESCRIPTIONS for WellPro II ---
      switch (stateNum) {
        case -1:
          stateDescr = "MODBUS ERROR";
          break;
        case 0:
          stateDescr = "POWERUP";
          break;
        case 1:
          stateDescr = "READY_TO_START";
          break;
        case 2:
          stateDescr = "UNLOAD";
          break;
        case 3:
          stateDescr = "MOTORSTART";
          break;
        case 4:
          stateDescr = "SPINDOWN";
          break;
        case 5:
          stateDescr = "CRANK";
          break;
        case 6:
          stateDescr = "CRANK_REST";
          break;
        case 7:
          stateDescr = "WARMUP";
          break;
        case 8:
          stateDescr = "WAITONEWT";
          break;
        case 9:
          stateDescr = "RAMP_TO_RATED_RPM";
          break;
        case 10:
          stateDescr = "LOADED";
          break;
        case 11:
          stateDescr = "COOLDOWN";
          break;
        case 12:
          stateDescr = "SHUTDOWN";
          break;
        case 13:
          stateDescr = "WAIT_ON_EOT";
          break;
        case 14:
          stateDescr = "WAIT_ON_EOTEWT";
          break;
        case 15:
          stateDescr = "WAIT_ON_LOAD_RPM";
          break;
        default:
          stateDescr = "STANDBY";
      }
      // --- SHUTDOWN DESCRIPTIONS for WellPro II ---
      switch (shutdownNum) {
        case -1:
          shutdownDescr = "";
          break;
        case 0:
          shutdownDescr = "Normal Operation";
          break;
        case 1:
          shutdownDescr = "Low Engine Oil Level";
          break;
        case 2:
          shutdownDescr = "Low Engine Jacket Water";
          break;
        case 3:
          shutdownDescr = "High 1st Stage Scrubber Level";
          break;
        case 4:
          shutdownDescr = "High 2nd Stage Scrubber Level";
          break;
        case 5:
          shutdownDescr = "ROC Override Active";
          break;
        case 6:
          shutdownDescr = "High Compressor Vibration";
          break;
        case 7:
          shutdownDescr = "Spare DI07";
          break;
        case 8:
          shutdownDescr = "Local Panel Emergency Stop";
          break;
        case 12:
          shutdownDescr = "Failure To Crank";
          break;
        case 14:
          shutdownDescr = "High Compressor Vibration";
          break;
        case 15:
          shutdownDescr = "Lost Engine J1939 Comm";
          break;
        case 21:
          shutdownDescr = "Lost Speed Signal/Engine Stall";
          break;
        case 38:
          shutdownDescr = "LoLo System Voltage";
          break;
        case 41:
          shutdownDescr = "HiHi System Voltage";
          break;
        case 42:
          shutdownDescr = "LoLo Field Pressure";
          break;
        case 45:
          shutdownDescr = "HiHi Field Pressure";
          break;
        case 46:
          shutdownDescr = "LoLo Interstage Pressure";
          break;
        case 49:
          shutdownDescr = "HiHi Interstage Pressure";
          break;
        case 50:
          shutdownDescr = "LoLo Discharge Pressure";
          break;
        case 53:
          shutdownDescr = "HiHi Discharge Pressure";
          break;
        case 58:
          shutdownDescr = "LoLo Compressor Oil Pressure";
          break;
        case 61:
          shutdownDescr = "HiHi Compressor Oil Pressure";
          break;
        case 62:
          shutdownDescr = "LoLo Suction Scrubber Pressure";
          break;
        case 65:
          shutdownDescr = "HiHi Suction Scrubber Pressure";
          break;
        case 78:
          shutdownDescr = "HiHi Discharge Temperature";
          break;
        case 74:
          shutdownDescr = "HiHi Temperature #2";
          break;
        default:
          shutdownDescr = "SHUTDOWN";
      }
    } else {
      // --- STATE DESCRIPTIONS for Other Controllers ---
      switch (stateNum) {
        case -1:
          stateDescr = "MODBUS ERROR";
          break;
        case 0:
          stateDescr = "STANDBY";
          break;
        case 25:
          stateDescr = "UNLOAD_ST";
          break;
        case 50:
          stateDescr = "START_DRIVER";
          break;
        case 60:
          stateDescr = "WARMUP";
          break;
        case 65:
          stateDescr = "RDY_TO_LOAD";
          break;
        case 70:
          stateDescr = "WAIT_ON_COT_PERM";
          break;
        case 80:
          stateDescr = "RAMP_TO_RATED";
          break;
        case 90:
          stateDescr = "AT_LOAD";
          break;
        case 100:
          stateDescr = "UNLOADING";
          break;
        case 110:
          stateDescr = "COOLDOWN";
          break;
        case 120:
          stateDescr = "STOP_DRIVER";
          break;
        case 130:
          stateDescr = "SHUTDOWN";
          break;
        default:
          stateDescr = "STANDBY";
      }
      // --- SHUTDOWN DESCRIPTIONS for Other Controllers ---
      switch (shutdownNum) {
        case -1:
          shutdownDescr = "";
          break;
        case 0:
          shutdownDescr = "Normal Operation";
          break;
        case 1:
          shutdownDescr = "Local Emergency Stop";
          break;
        case 7:
          shutdownDescr = "Lo Engine Oil Level";
          break;
        case 8:
          shutdownDescr = "Lo Engine Jacket Water Level";
          break;
        case 10:
          shutdownDescr = "Hi 1st Stage Scrubber Liquid Level";
          break;
        case 11:
          shutdownDescr = "Hi 2nd Stage Scrubber Liquid Level";
          break;
        case 13:
          shutdownDescr = "VFD PANEL SHUTDOWN";
          break;
        case 14:
          shutdownDescr = "High Compressor Vibration";
          break;
        case 117:
          shutdownDescr = "Engine Failure to Start";
          break;
        case 120:
          shutdownDescr = "Engine Failure to Stop";
          break;
        case 123:
          shutdownDescr = "Engine Stop Lamp";
          break;
        case 124:
          shutdownDescr = "Lost J1939 Com";
          break;
        case 125:
          shutdownDescr = "Lost RPM/Stall";
          break;
        case 257:
          shutdownDescr = "Lo Compressor Oil Pressure";
          break;
        case 455:
          shutdownDescr = "LoLo System Voltage";
          break;
        case 456:
          shutdownDescr = "HiHi System Voltage";
          break;
        case 457:
          shutdownDescr = "LoLo Field Pressure";
          break;
        case 458:
          shutdownDescr = "HiHi Field Pressure";
          break;
        case 459:
          shutdownDescr = "LoLo Interstage Pressure";
          break;
        case 460:
          shutdownDescr = "HiHi Interstage Pressure";
          break;
        case 461:
          shutdownDescr = "LoLo Discharge Pressure";
          break;
        case 462:
          shutdownDescr = "HiHi Discharge Pressure";
          break;
        case 463:
          shutdownDescr = "LoLo Flow Range";
          break;
        case 464:
          shutdownDescr = "HiHi Flow Range";
          break;
        case 465:
          shutdownDescr = "LoLo Suction Scrubber Pressure";
          break;
        case 466:
          shutdownDescr = "HiHi Suction Scrubber Pressure";
          break;
        case 467:
          shutdownDescr = "LoLo Compressor Oil Pressure";
          break;
        case 468:
          shutdownDescr = "HiHi Compressor Oil Pressure";
          break;
        case 542:
          shutdownDescr = "HiHi Discharge Temperature";
          break;
        case 543:
          shutdownDescr = "LoLo Discharge #2 Temperature";
          break;
        case 544:
          shutdownDescr = "HiHi Discharge #2 Temperature";
          break;
        default:
          shutdownDescr = "SHUTDOWN";
      }
    }
    return { stateDescr, shutdownDescr };
  }

  static getStatus = (lastReport, val) => {
    let status = "";
    const d = new Date().valueOf() / 1000;
    if (d - lastReport < 30 * 3600) {
      status = "ONLINE";
    } else if (d - lastReport < 48 * 3600) {
      status = "MISSED";
    } else if (val == -1) {
      status = "STANDBY";
    } else if (d - lastReport > 48 * 3600) {
      status = "OFFLINE";
    } else {
      status = "Loading";
    }
    return status;
  };
}
